<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
      <path
        d="M9.108 3.678c1.294-2.237 4.49-2.237 5.784 0l7.646 13.218C23.83 19.13 22.263 22 19.645 22H4.355c-2.618 0-4.185-2.869-2.892-5.104L9.108 3.678ZM13.16 4.68a1.332 1.332 0 0 0-2.322 0L3.194 17.897C2.643 18.85 3.335 20 4.354 20h15.291c1.02 0 1.712-1.15 1.161-2.103L13.161 4.68ZM12 16h.009H12Z"
      />
      <path
        d="M11 16a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1ZM12 8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z"
      />
    </g>
  </svg>
</template>
